import { createAuthClient } from "better-auth/react";

// Better Auth client. The SPA is served from the same origin as the Node auth
// server, which mounts Better Auth at /api/auth.
export const authClient = createAuthClient({
  baseURL: window.location.origin,
});

export const { useSession, signIn, signOut } = authClient;
